




















import Vue from 'vue';
import Component from 'vue-class-component';
import { Emit, Prop } from 'vue-property-decorator';

@Component({
    name: 'requirement-option',
})
export default class RequirementOption extends Vue {
    @Prop({ required: true })
    image!: string;

    @Emit('click')
    click() {}
}
